<template>
    <div class="div-reply">
        <v-row justify="center" align="center" :style="stylechat">
            <v-col cols="1">
                <v-avatar size="40" class="border-avatar">
                    <img v-if="reply_data.path_pic" :src="reply_data.path_pic"
                        class="imgProfilechat pictureRoomChat alligator-turtle" />
                    <img v-else-if="reply_data.type === 'bot'"
                        :src="`${publicPath}/assets/img/default_profile/bot-white.png'`"
                        class="imgProfilechat pictureRoomChat alligator-turtle">
                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png'`"
                        class="imgProfilechat pictureRoomChat alligator-turtle">
                </v-avatar>
            </v-col>
            <v-col cols="9" justify="start" align="start" class="pl-2">
                <p class="text-overflow mb-0 color-white"><b>{{ reply_data.nickname }}</b></p>
                <span class="color-white" v-if="reply_data.typeofmessage === 'image'">{{ $t('ChatSide.image') }}</span>
                <span class="color-white" v-if="reply_data.typeofmessage === 'file'">{{ $t('ChatSide.file') }}</span>
                <span class="color-white" v-if="reply_data.typeofmessage === 'sticker'">{{ $t('ChatSide.sticker')
                    }}</span>
                <span class="color-white" v-if="reply_data.typeofmessage === 'location'">{{ $t('ChatSide.location')
                    }}</span>
								<span class="color-white" v-if="reply_data.typeofmessage === 'video'">{{ $t('ChatSide.video')
                    }}</span>
								<span class="color-white" v-if="reply_data.typeofmessage === 'audio'">{{ $t('ChatSide.audio')
                    }}</span>
                <p class="color-white text-overflow mb-0"
                    v-if="reply_data.typeofmessage === 'message' || reply_data.typeofmessage === 'mention_message'" v-html="convertMsg(reply_data.message)">
                </p>

            </v-col>
            <v-col cols="1" align="end" justify="start" class="pt-0 pb-0 pr-0">
                <v-icon class="color-white fz-35"
                    v-if="reply_data.typeofmessage === 'file' && extension(reply_data.message) === 'fas fa-file-alt'">fas
                    fa-file-pdf</v-icon>
                <v-icon class="color-white fz-35"
                    v-else-if="reply_data.typeofmessage === 'file' && extension(reply_data.message) !== 'audio'">{{
                        extension(reply_data.message) }}</v-icon>
                <v-icon class="color-white fz-35"
                    v-else-if="reply_data.typeofmessage === 'file' && extension(reply_data.message) === 'audio'">fa-solid
                    fa-file-audio</v-icon>
                <img v-else-if="reply_data.typeofmessage === 'image'"
                    :src="reply_data.message" class="imgProfilechat pictureRoomChat alligator-turtle" />
                <img v-else-if="reply_data.typeofmessage === 'sticker'"
                    :src="reply_data.file_name" class="imgProfilechat pictureRoomChat alligator-turtle" />
                <v-icon class="color-white fz-25" v-else-if="reply_data.typeofmessage === 'location'">fa-solid
                    fa-location-dot</v-icon>
								<v-img v-else-if="reply_data.typeofmessage === 'video'" class="imgProfilechat pictureRoomChat alligator-turtle" :src="reply_data.thumbnail" :lazy-src="reply_data.thumbnail" lazy="loading">
                <template>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-icon>fa-solid fa-circle-play</v-icon>
                  </v-row>
                </template>
              </v-img>
            </v-col>
            <v-col cols="1" align="end" justify="start" class="pt-0 pl-0">
                <v-icon color="white" @click="closeReply()">mdi-close</v-icon>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props: {
        statemember: String,
        stateRichmenu: Boolean,
        reply_data: Object,
        reply_status: Boolean,
        listfriend: Array,
    },
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_PATH,
            stylechat: {
                "--Chat-Background": "white",
                "--Chat-HeaderColor": "white",
                "--Chat-HeaderBackground": "#2463af",
                "--Chat-HeaderPictureBorderRadius": "6px",
                "--Chat-ChatboxBackgroundOwner": "#34567f",
                "--Chat-ChatboxColorOwner": "white",
                "--Chat-ChatboxBorderOwner": "none",
                "--Chat-ChatboxBorderRadiusOwner": "6px",
                "--Chat-ChatboxColorNotSupportOwner": "#929292",
                "--Chat-ChatboxBackgroundOther": "#efefef",
                "--Chat-ChatboxColorOther": "#615f5f",
                "--Chat-ChatboxBorderOther": "none",
                "--Chat-ChatboxBorderRadiusOther": "6px",
                "--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
                "--Chat-TypingboxBackground": "#2463af",
                "--Chat-TypingboxColor": "white",
                "--Chat-QuickReplyButtonBorder": "#2463af",
                "--Chat-QuickReplyButtonBackground": "white",
                "--Chat-QuickReplyButtonColor": "#2463af",
                "--Chat-Icon-Active": "white",
                "--Chat-Template-Btn-Color": "#1976d2"
            },
        }
    },
    created() {
        // console.log("statemember =>", this.statemember);
        // console.log("reply_data => ", this.reply_data);
    },
    methods: {
        convertMsg(msg){
            msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2; cursor:pointer;">@');
            msg = msg.replace(/<\/tax>/g,'</span>');
            // console.log(msg)
            return msg
        },
        closeReply() {
            this.$emit('emitReply', { item: this.reply_data, value: false })
        },
        extension(path) {
            var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
            var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
            var pdf = ['pdf']
            var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm']
            var presentation = ['ppt', 'pps', 'pot', 'pptx']
            var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
            var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
            var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
            var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
            var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
            if (pdf.includes(extension)) {
                return 'fas fa-file-alt'
            } else if (archive.includes(extension)) {
                return 'fas fa-file-archive'
            } else if (spreadsheet.includes(extension)) {
                return 'fas fa-file-excel'
            } else if (presentation.includes(extension)) {
                return 'fas fa-file-powerpoint'
            } else if (word.includes(extension)) {
                return 'fas fa-file-word'
            } else if (execution.includes(extension)) {
                return 'fas fa-file-code'
            } else if (image.includes(extension)) {
                return 'fas fa-file-image'
            } else if (media.includes(extension)) {
                return 'media'
            } else if (audio.includes(extension)) {
                return 'fa-solid fa-file-audio'
            } else {
                return 'fas fa-file-alt'
            }
        },
    },
}
</script>
<style scoped>
.div-reply {
    height: 65px;
    background-color: rgba(0, 0, 0, 0.9);
    padding: 10px;
    bottom: 11px;
    position: relative;
}

.color-white {
    color: white !important;
}

.imgProfilechat {
    height: 40px;
    vertical-align: middle;
}

.pictureRoomChat {
    border-radius: var(--Chat-HeaderPictureBorderRadius) !important;
}

.alligator-turtle {
    object-fit: cover;
    object-position: 50% 0;
}
</style>